import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { StockService } from '../../services/stock.service';

@Component({
  selector: 'app-product-stock',
  templateUrl: './product-stock.component.html',
  styleUrls: ['./product-stock.component.css']
})
export class ProductStockComponent implements OnInit, OnDestroy {
  private _product;
  private _warehouse;
  quantity;

  product$: Observable<any>;
  productSub: Subscription;

  @Input() product;
  @Input() warehouse;

  constructor(
    private stockService: StockService) {
  }

  ngOnInit() {
    this.product$ = this.stockService.getProductStock(this.warehouse, this.product);
    this.productSub = this.product$.subscribe(product => {
      if (product != null){
        this.quantity = product.quantity;
      } else {
        this.quantity = 0;
      }
    });
  }
  ngOnDestroy() {
    this.productSub.unsubscribe();
  }

}
